import React from "react";
import Layout from "../../layouts/Layout";
import { Calendar, Badge, Select, Row, Col, Button } from "antd";
import _ from "lodash";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import ScheduleCheck from "./ScheduleCheck";
import ScheduleConfirm from "./ScheduleConfirm";
import Notification from "../../services/notification.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiService from '../../utils/api.service';
import HeaderCalendar from "../../components/general/HeaderCalendar";
import moment from "moment";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import helper from "../../utils/helper";

moment.updateLocale("en", {
  weekdaysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  // months:['January(TH)', 'February(TH)', 'March(TH)', 'April(TH)', 'May(TH)', 'June(TH)', 'July(TH)', 'August(TH)', 'September(TH)', 'October(TH)', 'November(TH)', 'December(TH)']
});

function getMonthData(value) {
  if (value.month() === 8) {
    return 1394;
  }
}

function monthCellRender(value) {
  const num = getMonthData(value);
  return num ? (
    <div className="notes-month">
      <section>{num}</section>
      <span>Backlog number</span>
    </div>
  ) : null;
}
const calendar_datadef = [
  { date: moment().add("d", -1), type: "error" },
  { date: moment().add("d", -1), type: "error" },
  { date: moment().add("d", -1), type: "error" },
  { date: moment(), type: "error" },
  { date: moment().add("d", 1), type: "warning" },
  { date: moment().add("d", 5), type: "warning" },
  { date: moment().add("d", 10), type: "warning" },
  { date: moment().add("d", 7), type: "success" },
  { date: moment().add("d", 3), type: "success" },
]

class MySchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calendar_data: [],
      currentDate: moment().add(1,'month').startOf('month'),
      checkList: [],
      dateEvent: {
        date: moment(),
        status: "รออนุมัติ",
        shiftList: [
          {
            locationName: "โรงพยาบาล Prince : วอร์ด ICU",
            shift: "กะเช้า : 07.00 - 19.00 น.",
          },
        ],
      },
      minDate: moment().add(1,'month').startOf('month').format('YYYY-MM-DD 00:00:00')
    };
    this.onPanelChange = this.onPanelChange.bind(this);
    this.dateCellRender = this.dateCellRender.bind(this);
    this.confirmShift = this.confirmShift.bind(this);
    console.log("moment", moment().format("DD-MMMM-YYYY"));
  }

  componentDidMount() {
    this.onReLoad()
  }
  onReLoad() {
    const { minDate, currentDate } = this.calMindate()
    // const { minDate, currentDate } = this.state
    this.setState({ minDate, currentDate }, () => {
      this.SearchWorkShiftSchedule(moment(currentDate).format('YYYY-MM-DD'))
    })
  }
  calMindate() {
    let currentDate = moment().add(1,'month').startOf('month')
    let minDate = moment().add(1,'month').startOf('month').format('YYYY-MM-DD 00:00:00')
    const today = Number(moment().format('D'))
    const configCut = 28
    if (today >= configCut) {
      currentDate = moment().add(2,'month').startOf('month')
      minDate = moment().add(2,'month').startOf('month').format('YYYY-MM-DD 00:00:00')
    }
    return { minDate, currentDate }
  }

  async SearchWorkShiftSchedule( selectDate = moment().format('YYYY-MM-DD') ) {
    try {
      const wardId = this.props.searchParams.get('wardId')
      const payload = { wardId: wardId, date: selectDate }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.BookShift.SearchWorkShiftSchedule(payload, header)
      if (resData.resultCode === "20000") {
        console.log('resData >>', resData.data)
        const _resData = resData.data
        let checkList = []
        if(_resData && Array.isArray(_resData)) {
          checkList = _resData.map(item => ({
            selected: !!item.bookingWork?.bookingWorkId,
            value: false,
            workShiftScheduleId: item.workShiftScheduleId,
            dataSelect: item
          }))
        }
        console.log('checkList >>', checkList)
        this.setState({ checkList })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  onPanelChange(date, mode) {
    console.log('e onPanelChange Calendar >>', date)
    console.log('e onPanelChange Calendar min>>', this.state.minDate)
    console.log('e onPanelChange Calendar check >>', helper.TIME.disableDate(date, this.state.minDate, null) === false)
    if (helper.TIME.disableDate(date, this.state.minDate, null) === false) {
      this.setState({ currentDate: date }, () => {
        this.selectDateEvent(date);
      });
    } else {
      this.setState({ checkList: [] })
    }
  }

  getListData(value) {
    let listData;
    let temp = _.find(
      this.state.calendar_data,
      (r) => r.date.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")
    );
    let date = this.state.currentDate;
    let month = date.month() + 1;
    if (temp && value.month() + 1 === month) {
      listData = [{ type: temp.type, content: "" }];
    }
    return listData || [];
  }

  dateCellRender(value) {
    const listData = this.getListData(value);
    return (
      <>
        {listData.map((item,index) => (
          <Badge key={index} status={item.type} />
        ))}
      </>
    );
  }
  selectDateEvent(date) {
    console.log('select date >>', moment(date).format('YYYY-MM-DD'))
    this.SearchWorkShiftSchedule(moment(date).format('YYYY-MM-DD'))
  }
  confirmShift (checkList = []) {
    const seCheckList = checkList.filter(item => item.value === true)
    const workShiftScheduleIds = seCheckList.map(item => item.workShiftScheduleId)
    const payload = {
      memberId: this.props?.user?.lineId?.memberId,
      workShiftScheduleId: workShiftScheduleIds
    }
    console.log('payload >>', payload)
    this.CreateBookingWork(payload)
  }
  async CreateBookingWork (payload = { workShiftScheduleId: [] }) {
    try {
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.BookShift.CreateBookingWork(payload, header)
      if(resData.resultCode === "20000"){
        console.log('resData >>', resData.data)
        // this.gotoStep1()
        Notification.success({ 
          title: "Success!", description: "บันทึกสำเร็จ" , 
          onCancel: () => {
            this.onReLoad()
          } 
        });
      } else {
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  gotoStep1() {
    this.props.navigate(`/schedule`);
  }

  render() {
    let { checkList, minDate } = this.state;
    let { currentDate } = this.state;
    const queryDate = this.props.searchParams.get('date')
    const queryHospitalId = this.props.searchParams.get('hospitalId')
    const queryhospitalName = this.props.searchParams.get('hospitalName')
    const querywardId = this.props.searchParams.get('wardId')
    const querywardName = this.props.searchParams.get('wardName')
    return (
      <Layout>
        {/* {queryDate}
        {queryHospitalId}
        {queryhospitalName}
        {wardId} */}
        <div className="container-schedule-step4">
          <div className="header">
            <div className="main-header-text">{queryhospitalName} : {querywardName}</div>
          </div>
          <div className="main-calendar padlr15">
            <Calendar
              value={this.state.currentDate}
              onSelect={(e) => {
                console.log("onSelect Calendar", e);
              }}
              onChange={(e) => {
                console.log('e onChange Calendar >>', e)
                this.setState({ currentDate: e }, () => {
                  if (e && e.isValid()) {
                    console.log(e);
                    this.selectDateEvent(e);
                  }
                });
                
              }}
              dateCellRender={this.dateCellRender}
              monthCellRender={monthCellRender}
              fullscreen={false}
              headerRender={({ value, type, onChange, onTypeChange }) => {
                return <HeaderCalendar value={value} onChange={onChange} minDate={minDate}/>
              }}
              onPanelChange={this.onPanelChange}
              disabledDate={(date) => helper.TIME.disableDate(date, this.state.minDate, null)}
            />
          </div>
          <ScheduleCheck
            currentDate={helper.FN.toDateFullThai(currentDate)}
            checkList={checkList}
            confirmShift={this.confirmShift}
            onChange={(e) => this.setState({ checkList:e })}
          />
        </div>
      </Layout>
    );
  }
}

function MyScheduleRoute(props) {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return <MySchedule navigate={navigate} searchParams={searchParams} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(MyScheduleRoute);

